import {useEffect, useState} from 'react';
import {Tween} from '@gongxigames/framework/core/fragments/tween/Tween';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';

export const useAnimationShow = (visible: boolean, updateManager: UpdateManager, duration?: number): number[] => {
    const [alpha, setAlpha] = useState(0);
    const [tween, setTween] = useState<Tween>();

    useEffect(() => {
        tween?.stop();

        if (!visible) {
            return setAlpha(0);
        }

        const newTween = updateManager.addTween({alpha: 0})
            .to({alpha: 1}, duration ?? 200)
            .onUpdate(setAlpha)
            .start();

        setAlpha(0);
        setTween(newTween);

        return () => newTween.stop();
    }, [visible]);

    return [alpha];
};
